import styled from "styled-components";
import { themes } from "../../theme/theme";

const ButtonC = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${themes.colors.colorBlue1};
  color: ${themes.colors.colorWhite};
  width: 17rem;
  transition: background 0.5s;
  font-size: 1.7rem;
  font-weight: 600;
  align-self: center;
  height: 7rem;
  width: 25rem;

  @media ${themes.device.laptopL} {
    font-size: 1.4rem;

    height: 5.5rem;
    width: 20rem;
  }

  @media ${themes.device.tabletS} {
    font-size: 1.4rem;
    margin-top: 3rem;
  }

  :hover {
    background: ${themes.colors.colorBlue2};
  }
`;
const MainTitle = styled.div`
  color: ${themes.colors.colorWhite};
  text-transform: uppercase;
  position: relative;
  white-space: pre-wrap;
  font-weight: bold;
  font-size: 6.4rem;
  line-height: 132.5%;

  @media ${themes.device.laptopL} {
    font-size: 4.8rem;
  }

  @media ${themes.device.tabletS} {
    font-size: 3.2rem;
    margin-bottom: 2rem;
  }
`;

const Subtitle = styled.div`
  font-size: 2rem;
  line-height: 171.7%;
  font-weight: 300;
  color: ${themes.colors.colorGray};

  @media ${themes.device.laptopL} {
    font-size: 1.7rem;
  }

  @media ${themes.device.mobileM} {
    font-size: 1.4rem;
  }
  text-align: center;
  width: 100%;
  white-space: pre-wrap;
`;

const TextBlock = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  justify-content: space-evenly;
  position: relative;
  z-index: 10;
  width: 75%;
  margin: auto;
  height: 40rem;

  text-align: center;

  @media ${themes.device.laptop} {
    width: 100%;
    display: flex;
    align-items: center;
  }
  @media (max-width: 550px) {
    height: 45rem;
  }
  @media (max-width: 450px) {
    height: auto;
  }
`;

const Container = styled.div`
  padding: 5rem 10%;

  align-items: center;
  background: ${themes.colors.mainColor};
  position: relative;
  z-index: 1;
  @media ${themes.device.laptop} {
    padding: 2rem 10%;
    height: auto;
  }
  @media ${themes.device.tabletS} {
    padding: 2rem 5%;
    height: auto;
  }
`;

const TextBl = styled(TextBlock)``;

const Subtit = styled(Subtitle)`
  white-space: pre-line;
`;

const ImageBorder = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.5);
`;
const VideoReviewDiv = styled.div`
  width: 85%;
  z-index: 21;
  margin: auto;
  margin-bottom: -8rem;

  @media ${themes.device.laptop} {
    width: 100%;
  }
 
  @media ${themes.device.tabletS} {
    margin-bottom: -2rem;
  }
`;
const BorderPlay = styled.div`
  width: 10rem;
  height: 10rem;
  border: 1px solid ${themes.colors.colorWhite};

  :hover {
    ::after {
      background: ${themes.colors.colorWhite};
      width: 10rem;
      height: 10rem;
      transition: width 0.6s, height 0.6s;
    }
    svg {
      path {
        fill: ${themes.colors.mainColor};
      }
    }
  }

  ::after {
    content: "";
    background: transparent;
    position: absolute;
    width: 3rem;
    height: 3rem;
    border-radius: 100%;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;

  cursor: pointer;
  position: relative;
  top: -35rem;
  left: 90rem;

  @media ${themes.device.desktop} {
    left: 46%;
  }
  @media (max-width: 1350px) {
    top: -30rem;
  }
  @media ${themes.device.laptop} {
    left: 43%;
  }
  @media (max-width: 900px) {
    top: -25rem;
  }
  @media ${themes.device.tabletM} {
    width: 8rem;
    height: 8rem;
    top: -16rem;
  }
  @media ${themes.device.tabletS} {
    width: 6.5rem;
    height: 6.5rem;
  }

  @media (max-width: 390px) {
    top: -14rem;
  }
  @media (max-width: 350px) {
    top: -12rem;
  }
`;

export {
  Container,
  MainTitle,
  TextBl,
  Subtit,
  VideoReviewDiv,
  ImageBorder,
  BorderPlay,
  ButtonC
};
